import React from 'react';
import { CalendarDays, TrendingDown } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function OpeningHook() {
  return <AnimatedSection className="py-24 bg-navy-800 relative px-4 sm:px-6 lg:px-8" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <div className="flex justify-center mb-8" data-id="element-107">
          <div className="w-16 h-16 rounded-2xl bg-navy-900 border border-navy-700 flex items-center justify-center shadow-lg" data-id="element-108">
            <CalendarDays className="w-8 h-8 text-gold-400" data-id="element-109" />
          </div>
        </div>

        <div className="space-y-8 text-lg sm:text-xl text-slate-300 leading-relaxed text-center" data-id="element-110">
          <p data-id="element-111">
            Es el día 20 del mes. Abres tu aplicación bancaria y, otra vez, el
            número es mucho más bajo de lo que esperabas. No has comprado nada
            extraordinario, no te fuiste de viaje ni tuviste una emergencia.{' '}
            <span className="text-white font-medium" data-id="element-112">
              Simplemente, el dinero ya no está.
            </span>
          </p>

          <div className="h-px w-24 bg-navy-700 mx-auto" data-id="element-113" />

          <p data-id="element-114">
            Trabajas duro, tienes un ingreso estable y te va "bien", pero
            sientes que estás corriendo en una caminadora: te esfuerzas mucho,
            pero no avanzas ni un centímetro hacia la seguridad que quieres.
          </p>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-115" />
    </AnimatedSection>;
}